import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { InvestorBankAccountAssignment, InvestorBankAccountDetails } from "../../../../api/types/bankAccountTypes";
import type { ChangeRequestDetails } from "../../../../api/types/changeRequestsTypes";
import type { InvestorFundPermissionSet } from "../../../../store/state/user/types";

interface ContextValue {
  canUserEdit: boolean;
  investorId: string;
  fundInvestors: InvestorFundPermissionSet[];
  availableFundInvestorIds: string[];
  bankAccounts: InvestorBankAccountDetails[];
  fundAssignments: InvestorBankAccountAssignment[];
  pendingChangeRequests: ChangeRequestDetails[];
}

const BankAccountsContext = createContext<ContextValue | undefined>(undefined);

export const BankAccountsContextProvider = ({
  children,
  canUserEdit,
  investorId,
  fundInvestors,
  availableFundInvestorIds,
  bankAccounts,
  fundAssignments,
  pendingChangeRequests,
}: PropsWithChildren<ContextValue>) => {
  return (
    <BankAccountsContext
      value={{
        canUserEdit,
        investorId,
        fundInvestors,
        availableFundInvestorIds,
        bankAccounts,
        fundAssignments,
        pendingChangeRequests,
      }}
    >
      {children}
    </BankAccountsContext>
  );
};

export default BankAccountsContext;
